import { combineReducers } from 'redux';
import { footerLinksSlice } from 'Douleutaras/redux/data/footerLinks/footerLinksSlice';
import { categoriesSlice } from 'Douleutaras/redux/data/categories/categoriesSlice';
import { jobAttributesSlice } from 'Douleutaras/redux/data/jobAttributes/jobAttributes';
import { jobAttributeValuesSlice } from 'Douleutaras/redux/data/jobAttributeValues/jobAttributeValues';
import { jobMunicipalitySlice } from 'Douleutaras/redux/data/jobMunicipality/jobMunicipalitySlice';
import { jobBidsSlice } from 'Douleutaras/redux/data/jobBids/jobBidsSlice';
import { jobBidsFeedbackSlice } from 'Douleutaras/redux/data/jobBids/jobBidsFeedbackSlice';
import { jobBidsBookNowSlice } from 'Douleutaras/redux/data/jobBids/jobBidsBookNowSlice';
import { businessUnitsSlice } from 'Douleutaras/redux/data/businessUnits/businessUnitsSlice';
import sellerProfilesReducer from 'Douleutaras/redux/data/seller/sellerProfilesSlice';
import sellerProfilesBadgesReducer from 'Douleutaras/redux/data/seller/sellerProfilesBadgesSlice';
import sellerProfilesCategoriesReducer from 'Douleutaras/redux/data/seller/sellerProfilesCategoriesSlice';
import sellerProfilesPortfolioReducer from 'Douleutaras/redux/data/seller/sellerProfilesPortfolioSlice';
import sellerProfilesMunicipalitiesReducer from 'Douleutaras/redux/data/seller/sellerProfilesMunicipalitiesSlice';
import bsdirReducers from 'Douleutaras/redux/data/bsdir/bsdirReducers';
import servicesPricingReducer from 'Douleutaras/redux/data/seller/servicesPricingSlice';
import me from 'Douleutaras/redux/data/users/meSlice';
import notificationsReducer from 'Douleutaras/redux/data/notifications/notificationsSlice';
import { conversationsSlice } from 'Douleutaras/redux/data/conversations/conversationsSlice';
import { messagesSlice } from 'Douleutaras/redux/data/conversations/messagesSlice';
import { mediaAttachmentsSlice } from 'Douleutaras/redux/data/conversations/mediaAttachmentsSlice';
import promotionBannerSlice from 'Douleutaras/redux/data/ui/promotionBannerSlice';
import { needHelpOptionsSlice } from 'Douleutaras/redux/data/ccf/needHelpOptionsSlice';
import { snackbarSlice } from 'Douleutaras/redux/data/ui/snackbarSlice';
import { contactsSlice } from 'Douleutaras/redux/data/settings/contactsSlice';
import { pushNotificationsSlice } from 'Douleutaras/redux/data/settings/pushNotificationsSlice';
import { portfolioSlice } from 'Douleutaras/redux/data/settings/portfolioSlice';
import { transactionsSlice } from 'Douleutaras/redux/data/settings/transactionSlice';
import { invoicesCrmSlice } from 'Douleutaras/redux/data/settings/invoicesCrmSlice';
import { jobBidsStatusBuyerSlice } from 'Douleutaras/redux/data/jobBids/jobBidsStatusBuyerSlice';
import { matchedProInfoSlice } from 'Douleutaras/redux/data/jobBids/matchedProInfoSlice';
import { feedbacksSlice } from 'Douleutaras/redux/data/settings/feedbacksSlice';
import { feedbackResponseSlice } from 'Douleutaras/redux/data/settings/feedbackResponseSlice';
import jobPriceDefiningQuestionsSlice from 'Douleutaras/redux/data/jobPriceDefiningQuestions/jobPriceDefiningQuestionsSlice';
import jobPriceDefiningAnswersSlice from 'Douleutaras/redux/data/jobPriceDefiningAnswers/jobPriceDefiningAnswersSlice';
import { registrationSettingsSlice } from 'Douleutaras/redux/data/settings/registrationSettingsSlice';
import { jobBidsWithOuterSlice } from 'Douleutaras/redux/data/jobBidsWithOuter/jobBidsWithOuter';
import { proPaymentRequestSlice } from 'Douleutaras/redux/data/payments/proPaymentRequestSlice';
import { customerOnlinePaymentSlice } from 'Douleutaras/redux/data/payments/customerOnlinePaymentSlice';
import { bidHistorySlice } from 'Douleutaras/redux/data/history/bidHistorySlice';
import { jobHistorySlice } from 'Douleutaras/redux/data/history/jobHistorySlice';
import { siteFeatureFlagsSlice } from 'Douleutaras/redux/data/settings/siteFeatureFlagsSlice';
import { supportSlice } from 'Douleutaras/redux/data/settings/supportSlice';
// v2
import { autoDealsSlice } from 'Douleutaras/redux/data/v2/autodeals/autodealsSlice';
import { crmSlice } from 'Douleutaras/redux/data/v2/crm/crmSlice';
import { aswSlice } from 'Douleutaras/redux/data/v2/asw/aswSlice';
import { crmStatusesSlice } from 'Douleutaras/redux/data/v2/crm/crmStatuses.Slice';
import { categoryFormSlice } from 'Douleutaras/redux/data/v2/categoryForm/categoryFormSlice';
import { bookNowEntriesSlice } from 'Douleutaras/redux/data/v2/crm/bookNowEntriesSlice';
import { bidPriceDefineAnswersSlice } from 'Douleutaras/redux/data/v2/bids/priceDefineQuestions';
import { jobsSlice as jobsSliceV2 } from 'Douleutaras/redux/data/v2/jobs/jobsSlice';
import { jobsSearchSlice as jobsSearchSliceV2 } from 'Douleutaras/redux/data/v2/jobs/searchSlice';
import { countersSlice } from 'Douleutaras/redux/data/v2/counters/countersSlice';
import { invoicesSliceV2 } from 'Douleutaras/redux/data/settings/invoicesSlice';
import { invoicesSlice } from 'Douleutaras/redux/data/invoices/invoicesSlice';
import { billingsSlice } from 'Douleutaras/redux/data/v2/settings/billingSlice';
import { paymentBackendSlice } from 'Douleutaras/redux/data/v2/settings/paymentBackend.slice';
import userDebtSlice from 'Douleutaras/redux/data/userDebt/userDebt';
import { settingsSlice } from 'Douleutaras/redux/data/users/settingsSlice';
import { stripeSlice } from 'Douleutaras/redux/data/payments/stripeSlice';
import { outerJobSlice } from 'Douleutaras/redux/data/jobs/outerJobSlice';
import { outerJobNotesSlice } from 'Douleutaras/redux/data/jobs/outerJobNotesSlice';
import { noteSlice } from 'Douleutaras/redux/data/notes/noteSlice';
import authProvidersReducer from 'Douleutaras/redux/data/auth/authProvidersSlice';
import authViewReducer from 'Douleutaras/redux/data/auth/authViewSlice';
import { authSlice } from 'Douleutaras/redux/data/auth/authSlice';
import { jobsSlice } from 'Douleutaras/redux/data/jobs/jobsSlice';
import { usersSlice } from 'Douleutaras/redux/data/users/usersSlice';
import { modalsSlice } from 'Douleutaras/redux/data/modals/modalsSlice';
import { statsSlice } from 'Douleutaras/redux/data/stats/statsSlice';
import { bonusPageSlice } from 'Douleutaras/redux/data/bonusPage/bonusPageSlice';
import { sellerReviewsSlice } from 'Douleutaras/redux/data/seller/sellerReviewsSlice';
import { sellerReviewsResponseSlice } from 'Douleutaras/redux/data/seller/sellerReviewsResponseSlice';
import spinReducer from 'Douleutaras/redux/data/ui/spinSlice';
import { categoriesTosSlice } from 'Douleutaras/redux/data/categories/categoriesTosSlice';
import { categoriesMenuSlice } from 'Douleutaras/redux/data/v2/categoriesMenu/categoriesMenuSlice';
import prosReducers from 'Douleutaras/redux/data/pros/prosReducers';
import { prosListReducer } from 'Douleutaras/redux/data/proList/prosListSlice';

const paymentReducers = combineReducers({
  stripeAuto: stripeSlice.reducer,
  proPaymentRequest: proPaymentRequestSlice.reducer,
  customerOnlinePayment: customerOnlinePaymentSlice.reducer
});

export default combineReducers({
  auth: authSlice.reducer,
  me: me.reducer,
  businessUnits: businessUnitsSlice.reducer,
  categories: categoriesSlice.reducer,
  categoriesTos: categoriesTosSlice.reducer,
  conversations: conversationsSlice.reducer,
  bidHistory: bidHistorySlice.reducer,
  jobHistory: jobHistorySlice.reducer,
  jobAttributes: jobAttributesSlice.reducer,
  jobAttributeValues: jobAttributeValuesSlice.reducer,
  jobBids: jobBidsSlice.reducer,
  jobBidsBookNow: jobBidsBookNowSlice.reducer,
  jobBidsFeedback: jobBidsFeedbackSlice.reducer,
  jobBidsStatusBuyer: jobBidsStatusBuyerSlice.reducer,
  jobBidsWithOuter: jobBidsWithOuterSlice.reducer,
  matchedProInfo: matchedProInfoSlice.reducer,
  jobPriceDefiningQuestions: jobPriceDefiningQuestionsSlice.reducer,
  jobPriceDefiningAnswers: jobPriceDefiningAnswersSlice.reducer,
  jobMunicipality: jobMunicipalitySlice.reducer,
  jobs: jobsSlice.reducer,
  outerJobs: outerJobSlice.reducer,
  outerJobNotes: outerJobNotesSlice.reducer,
  note: noteSlice.reducer,
  footerLinks: footerLinksSlice.reducer,
  featureFlags: siteFeatureFlagsSlice.reducer,
  support: supportSlice.reducer,
  users: usersSlice.reducer,
  messages: messagesSlice.reducer,
  mediaAttachments: mediaAttachmentsSlice.reducer,
  notifications: notificationsReducer,
  promotionBanner: promotionBannerSlice.reducer,
  needHelpOptions: needHelpOptionsSlice.reducer,
  snackbar: snackbarSlice.reducer,
  spin: spinReducer,
  sellerProfiles: sellerProfilesReducer,
  sellerProfilesBadges: sellerProfilesBadgesReducer,
  sellerProfilesCategories: sellerProfilesCategoriesReducer,
  sellerProfilesPortfolio: sellerProfilesPortfolioReducer,
  sellerProfilesMunicipalities: sellerProfilesMunicipalitiesReducer,
  bsdir: bsdirReducers,
  sellerReviews: sellerReviewsSlice.reducer,
  sellerReviewsResponse: sellerReviewsResponseSlice.reducer,
  servicesPricing: servicesPricingReducer,
  contacts: contactsSlice.reducer,
  pushNotifications: pushNotificationsSlice.reducer,
  portfolios: portfolioSlice.reducer,
  feedbacks: feedbacksSlice.reducer,
  feedbackResponse: feedbackResponseSlice.reducer,
  modals: modalsSlice.reducer,
  transactions: transactionsSlice.reducer,
  crmInvoices: invoicesCrmSlice.reducer,
  registrationSettings: registrationSettingsSlice.reducer,
  userSettings: settingsSlice.reducer,
  stats: statsSlice.reducer,
  bonusPage: bonusPageSlice.reducer,
  invoices: invoicesSlice.reducer,
  userDebt: userDebtSlice.reducer,
  payments: paymentReducers,
  pros: prosReducers,
  prosList: prosListReducer,

  // v2
  autoDeals: autoDealsSlice.reducer,
  crm: crmSlice.reducer,
  crmStatuses: crmStatusesSlice.reducer,
  asw: aswSlice.reducer,
  categoryForm: categoryFormSlice.reducer,
  counters: countersSlice.reducer,
  bidPriceDefineAnswers: bidPriceDefineAnswersSlice.reducer,
  bookNowEntries: bookNowEntriesSlice.reducer,
  jobsV2: jobsSliceV2.reducer,
  jobsSearchV2: jobsSearchSliceV2.reducer,
  invoicesV2: invoicesSliceV2.reducer,
  billings: billingsSlice.reducer,
  paymentBackend: paymentBackendSlice.reducer,
  authProviders: authProvidersReducer,
  authView: authViewReducer,
  categoriesMenu: categoriesMenuSlice.reducer
});
